import React from 'react'
import HowItWorksImage1 from '../../assets/imgs/how-it-works-image-1.svg'
import HowItWorksImage2 from '../../assets/imgs/how-it-works-image-2.svg'
import HowItWorksImage3 from '../../assets/imgs/how-it-works-image-3.svg'
import '../../styles/HowItWorks.scss'

const HowItWorks = () => {
  return (
    <div className="how-it-works text-center">
      <div className="container">
        <h1 className="main-heading how-it-works-heading mb-3 pt-5">
          How it works
        </h1>
        <div className="container">
          <div className="row gx-0">
            <div className="col-12 col-sm-12 col-md-4">
              <img src={HowItWorksImage1} alt="" />
            </div>
            <div className="col-12 col-sm-12 col-md-4">
              <img src={HowItWorksImage2} alt="" />
            </div>
            <div className="col-12 col-sm-12 col-md-4">
              <img src={HowItWorksImage3} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HowItWorks
